module.exports = __webpack_public_path__ + "static/media/Dashboard_Sidebar.245e0996.svg";